import { render } from "./BaseItemSubGroup.vue?vue&type=template&id=268ecf9a"
import script from "./BaseItemSubGroup.vue?vue&type=script&lang=js"
export * from "./BaseItemSubGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__